import React, { FC, PropsWithChildren } from 'react';
import useToggle from '@hooks/useToggle';
import { Collapse, MenuItem, SxProps, Typography } from '@mui/material';
import { themePalette } from '@theme/muiTheme';
import { DropdownIcon } from '@utils/iconsDefs';

type CollapsedSectionProps = PropsWithChildren & {
  title: string;
  controls?: {
    isExpanded: boolean;
    toggle: () => void;
  };
  defaultExpanded?: boolean;
  sx?: SxProps;
  unmountOnExit?: boolean;
};

const CollapsedSection: FC<CollapsedSectionProps> = ({
  title,
  children,
  controls,
  defaultExpanded = false,
  sx,
  unmountOnExit = true,
}) => {
  const [isExpanded, { toggle }] = useToggle(defaultExpanded);

  return (
    <>
      <MenuItem
        sx={{ justifyContent: 'space-between', whiteSpace: 'nowrap', ...sx }}
        onClick={controls?.toggle || toggle}
      >
        <Typography variant="h5">{title}</Typography>

        <DropdownIcon
          fill={themePalette.grey[isExpanded ? 1000 : 800]}
          style={{ transform: isExpanded ? 'rotate(180deg)' : '' }}
        />
      </MenuItem>

      <Collapse
        in={controls?.isExpanded || isExpanded}
        timeout="auto"
        unmountOnExit={unmountOnExit}
      >
        {children}
      </Collapse>
    </>
  );
};

export default CollapsedSection;
